export default "__VITE_ASSET__CHwS19uQ__"